import type { Resource } from './types';

// Mirrors backend/lambdas/arm-resource-actions/index.py's _DELETE_HANDLERS - kept in sync
// deliberately so the UI never lets someone select something delete will just reject.
export const DELETABLE_TYPES = new Set([
  'ec2-instance', 'ebs-volume', 'nat-gateway', 'elastic-ip', 'rds-instance',
  'elb', 'asg', 'lambda-function', 'dynamodb-table', 'sqs-queue', 'sns-topic',
]);

// Tags vedniq-portal writes on everything it provisions for a lab (see vedniq-portal's IAM
// Naming Conventions) - used to tell "this is a known lab resource" from "nobody claimed this".
export const LAB_ATTRIBUTION_TAGS = ['lab-owner', 'session-id', 'managed-by'];

export const RUNNING_STATES = new Set(['running', 'available', 'active', 'pending', 'starting', 'backing-up']);

// API Gateway hard-caps a REST API Lambda proxy integration at 29s no matter what the Lambda's own
// timeout says (see arm-resource-actions's 25s timeout in the CDK stack) - deleting resources one
// at a time per account, a batch much larger than this risks the client getting a 504 while the
// Lambda keeps deleting in the background. Keep selections small enough to comfortably finish.
export const MAX_BULK_DELETE = 25;

export const resourceKey = (r: Pick<Resource, 'account_id' | 'resource_id'>) => `${r.account_id}#${r.resource_id}`;

export function formatCostPerDay(cost: number | null | undefined): string {
  if (cost === null || cost === undefined) return '—';
  if (cost === 0) return '$0.00';
  return `$${cost.toFixed(2)}/day`;
}

export function ageHours(resource: Pick<Resource, 'created_at' | 'first_seen_at'>): number {
  const since = resource.created_at || resource.first_seen_at;
  return (Date.now() - new Date(since).getTime()) / (1000 * 60 * 60);
}

export function isUnattributed(resource: Pick<Resource, 'tags'>): boolean {
  return !LAB_ATTRIBUTION_TAGS.some((key) => resource.tags[key]);
}
